import { validate, createValidationSchema } from "@";

export const schema = createValidationSchema({
  title: validate("req"),
  body: validate("req"),
  key: validate("req"),
});

export const defaultValues = {
  id: null,
  title: "",
  body: "",
  key: "",
  isActive: true,
};
